import { render, staticRenderFns } from "./save.vue?vue&type=template&id=99bb8336&scoped=true"
import script from "./save.vue?vue&type=script&lang=js"
export * from "./save.vue?vue&type=script&lang=js"
import style0 from "./save.vue?vue&type=style&index=0&id=99bb8336&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bb8336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99bb8336')) {
      api.createRecord('99bb8336', component.options)
    } else {
      api.reload('99bb8336', component.options)
    }
    module.hot.accept("./save.vue?vue&type=template&id=99bb8336&scoped=true", function () {
      api.rerender('99bb8336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/searchTerm/save.vue"
export default component.exports